module.exports = __webpack_public_path__ + "static/media/ppe_saf_glo.18e1771d.png";